import React from 'react';
import cn from 'classnames';
import s from './AnimatedHotspot.scss';
var AnimatedHotspot = React.forwardRef(function (_a, ref) {
    var className = _a.className, onMouseOver = _a.onMouseOver;
    return (React.createElement("div", { className: cn(s['root'], className), ref: ref },
        React.createElement("svg", { viewBox: "0 0 105 122", fill: "none", xmlns: "http://www.w3.org/2000/svg", onMouseOver: onMouseOver },
            React.createElement("path", { className: cn(s['hexagon'], s['hexagon-first']), d: "M0 30.5159V91.5053L52.5 122L105 91.5053V30.5159L52.5 0L0 30.5159Z", fill: "#00E59B" }),
            React.createElement("path", { className: cn(s['hexagon'], s['hexagon-second']), d: "M0 30.5159V91.5053L52.5 122L105 91.5053V30.5159L52.5 0L0 30.5159Z", fill: "#00E59B" }),
            React.createElement("path", { className: cn(s['hexagon'], s['hexagon-third']), d: "M0 30.5159V91.5053L52.5 122L105 91.5053V30.5159L52.5 0L0 30.5159Z", fill: "#00E59B" }))));
});
AnimatedHotspot.displayName = 'AnimatedHotspot';
export default AnimatedHotspot;
//# sourceMappingURL=AnimatedHotspot.js.map